/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractRuleSetCustomizationSummaryDto
 */
export interface ContractRuleSetCustomizationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof ContractRuleSetCustomizationSummaryDto
     */
    numberOfCustomizations?: number;
}

/**
 * Check if a given object implements the ContractRuleSetCustomizationSummaryDto interface.
 */
export function instanceOfContractRuleSetCustomizationSummaryDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContractRuleSetCustomizationSummaryDtoFromJSON(json: any): ContractRuleSetCustomizationSummaryDto {
    return ContractRuleSetCustomizationSummaryDtoFromJSONTyped(json, false);
}

export function ContractRuleSetCustomizationSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractRuleSetCustomizationSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'numberOfCustomizations': !exists(json, 'numberOfCustomizations') ? undefined : json['numberOfCustomizations'],
    };
}

export function ContractRuleSetCustomizationSummaryDtoToJSON(value?: ContractRuleSetCustomizationSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'numberOfCustomizations': value.numberOfCustomizations,
    };
}

